import { useEffect, useState } from "react";
import api from "@/lib/api";
import { eslesir, ayniKod, normTr } from "@/lib/ara";

const SAYFA = 24;
const kAnahtar = (uid) => `bayi-katalog-${uid}`;
const bAnahtar = (uid) => `bayi-bekleyen-${uid}`;
const oku = (k) => { try { return JSON.parse(localStorage.getItem(k)); } catch { return null; } };

export const agHatasi = (e) => !e?.response;

export const useCevrimici = () => {
  const [on, setOn] = useState(navigator.onLine);
  useEffect(() => {
    const a = () => setOn(true);
    const b = () => setOn(false);
    window.addEventListener("online", a);
    window.addEventListener("offline", b);
    return () => { window.removeEventListener("online", a); window.removeEventListener("offline", b); };
  }, []);
  return on;
};

export const katalog = (uid) => oku(kAnahtar(uid));

export const katalogYenile = async (uid) => {
  const { data } = await api.get("/bayi/katalog");
  try { localStorage.setItem(kAnahtar(uid), JSON.stringify(data)); } catch { }
  return data;
};

const yilUyar = (u, y) => (u.araclar || []).some((a) => (a.yil_bas || a.yil_bit) && (!a.yil_bas || a.yil_bas <= y) && (!a.yil_bit || a.yil_bit >= y));

const metin = (u) => [u.kod, u.ad, u.kategori, u.olcu, u.marka, u.oem_no, ...(u.araclar || []).flatMap((a) => [a.marka, a.model, a.motor])];

const eslesUrun = (u, q) => String(q || "").split(/\s+/).filter(Boolean).every((t) => eslesir(t, metin(u)) || (/^(19[5-9]\d|20\d\d|2100)$/.test(t) && yilUyar(u, Number(t))));

const aracUyar = (a, marka, model, yil) => ayniKod(a.marka, marka) && (!model || ayniKod(a.model, model))
  && (!yil || ((!a.yil_bas || a.yil_bas <= yil) && (!a.yil_bit || a.yil_bit >= yil)));

export const katalogAra = (uid, { q = "", kod = "", sayfa = 1, stokta = false, marka = "", model = "", yil = null }) => {
  const k = katalog(uid);
  if (!k) return null;
  let l = k.urunler.filter((u) => (!stokta || u.stok > 0) && (kod ? ayniKod(u.kod, kod) : eslesUrun(u, q))
    && (!marka || (u.araclar || []).some((a) => aracUyar(a, marka, model, yil))));
  const toplam = l.length;
  l = kod ? l : l.slice((sayfa - 1) * SAYFA, sayfa * SAYFA);
  return { toplam, sayfa, sayfa_boyu: SAYFA, urunler: l, cevrimdisi: true, zaman: k.zaman };
};

export const aracAgaci = (urunler) => {
  const m = new Map();
  const yilSon = new Date().getFullYear();
  urunler.forEach((u) => (u.araclar || []).forEach((a) => {
    const mk = String(a.marka || "").trim().toLocaleUpperCase("tr");
    if (!mk) return;
    const mkA = normTr(mk);
    const b = m.get(mkA) || { marka: mk, ids: new Set(), modeller: new Map() };
    b.ids.add(u.id);
    const md = String(a.model || "").trim().toLocaleUpperCase("tr");
    if (md) {
      const mdA = normTr(md);
      const x = b.modeller.get(mdA) || { model: md, ids: new Set(), yillar: new Set() };
      x.ids.add(u.id);
      if (a.yil_bas || a.yil_bit) {
        for (let y = a.yil_bas || a.yil_bit; y <= Math.min(a.yil_bit || yilSon, yilSon); y += 1) x.yillar.add(y);
      }
      b.modeller.set(mdA, x);
    }
    m.set(mkA, b);
  }));
  return [...m.values()].map((b) => ({ marka: b.marka, adet: b.ids.size,
    modeller: [...b.modeller.values()].map((x) => ({ model: x.model, adet: x.ids.size, yillar: [...x.yillar].sort((p, r) => r - p) })).sort((p, r) => p.model.localeCompare(r.model, "tr")) }))
    .sort((p, r) => p.marka.localeCompare(r.marka, "tr"));
};

export const bekleyen = (uid) => oku(bAnahtar(uid));
export const bekleyenKaydet = (uid, v) => (v ? localStorage.setItem(bAnahtar(uid), JSON.stringify(v)) : localStorage.removeItem(bAnahtar(uid)));
